import {useQuery} from '@tanstack/react-query';

import api from 'app/modules/Remote/api';

export interface StyleableAttribute {
  name: string;
  values: string[];
}

// The list is cached as the API returns it, so every consumer shares one entry per overlay and
// filters it for its own purpose.
export const useStyleableAttributes = (featureCollectionId: number, enabled = true) =>
  useQuery({
    queryKey: ['styleableAttributes', featureCollectionId],
    queryFn: async (): Promise<StyleableAttribute[]> => {
      const response = await api.featureCollections.listStyleableAttributes(featureCollectionId);
      return (response.get('data')?.toJS() as StyleableAttribute[] | undefined) ?? [];
    },
    // Mirror the backend pmtiles CachingReader Redis TTL.
    staleTime: 1000 * 60 * 60 * 4,
    enabled,
  });
